﻿// @ts-nocheck
// tab switching

// ========== Tab Management ==========
async function switchTab(tabName) {
  if (!isTabVisibleForBillingModel(tabName)) {
    tabName = "dashboard";
  }
  currentView = tabName;
  const tabMeta = getTabMetaForCurrentModel(tabName);
  
  // Update active button
  document.querySelectorAll(".tab-btn").forEach((btn) => {
    btn.classList.remove("active");
    btn.style.borderBottomColor = "transparent";
    btn.style.color = "var(--text-primary)";
    btn.setAttribute("aria-selected", "false");
    btn.setAttribute("tabindex", "-1");
  });
  const activeBtn = document.querySelector(`[data-tab="${tabName}"]`);
  activeBtn.classList.add("active");
  activeBtn.style.borderBottomColor = "var(--primary)";
  activeBtn.style.color = "var(--primary)";
  activeBtn.setAttribute("aria-selected", "true");
  activeBtn.setAttribute("tabindex", "0");

  // Hide/show content
  document.querySelectorAll(".tab-content").forEach((content) => {
    content.style.display = "none";
  });
  document.querySelectorAll(".tab-content").forEach((content) => {
    content.setAttribute("aria-hidden", "true");
  });
  const activePanel = document.getElementById(`${tabName}-tab`);
  activePanel.style.display = "block";
  activePanel.setAttribute("aria-hidden", "false");

  const titleEl = document.getElementById("sectionTitle");
  const descriptionEl = document.getElementById("sectionDescription");
  if (titleEl) titleEl.textContent = tabMeta.title;
  if (descriptionEl) descriptionEl.textContent = tabMeta.description;

  // If switching to reports, reload sessions first then populate
  if (tabName === "reports") {
    await loadSessions(); // Reload fresh from server
    populateMonthSelect();
    const select = document.getElementById("reportMonthSelect");
    if (select && select.options.length > 1) {
      // Auto-select the first available month
      select.selectedIndex = 1;
      const month = select.value;
      if (month) renderMonthlyReport(month);
    }
  }

  if (tabName === "clients") {
    await loadClients();
  }
  if (tabName === "projects") {
    // Make sure clients are loaded so the picker is populated
    if (clients.length === 0) await loadClients();
    renderClientPicker();
  }
}

// Inline-onclick wrapper used by various templates.
function selectTab(name) { return switchTab(name); }
window.selectTab = selectTab;
